module.exports = __webpack_public_path__ + "img/toile-libre.png";